var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 4.12305,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-0.709207 3.25 4.12305)",
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 4.12305,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-0.709207 3.25 4.12305)",
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2604_3250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8719 27.1659L23.4976 23.8741M23.4976 23.8741L20.2058 27.2484M23.4976 23.8741L23.5904 31.3735M30.5546 29.1121C31.3619 28.659 31.9952 27.95 32.3547 27.0969C32.7142 26.2438 32.7794 25.2953 32.54 24.4011C32.3006 23.5069 31.7702 22.7179 31.0325 22.1586C30.2948 21.5993 29.3919 21.3016 28.4663 21.3124L27.4163 21.3254C27.152 20.353 26.6707 19.4531 26.0086 18.6934C25.3465 17.9338 24.5208 17.3341 23.5935 16.9395C22.6663 16.545 21.6616 16.3657 20.6551 16.4153C19.6487 16.4648 18.6665 16.7419 17.7825 17.2257C16.8985 17.7095 16.1357 18.3874 15.5514 19.2084C14.9671 20.0294 14.5766 20.9722 14.4091 21.9659C14.2416 22.9596 14.3016 23.9784 14.5845 24.9456C14.8674 25.9127 15.3659 26.8032 16.0425 27.55",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2604_3250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.375 13.998) rotate(-0.709207)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.1caaa0410f03aa76e907aee9c6193809.svg";
export { ForwardRef as ReactComponent };